<form [formGroup]="userFeedback.feedbackForm"
      (ngSubmit)="userFeedback.sendFeedback()">
  <div class="title">{{'GX_WRAPPED.FEEDBACK_TITLE' | translate}}</div>

  <div class="emoticonContainer">
    @for (emoticon of userFeedback.emoticonsList; track emoticon; let i = $index) {
      <input type="radio"
             id="rating_{{userFeedback.getRating(i)}}"
             name="rating"
             formControlName="rating"
             value="{{userFeedback.getRating(i)}}">
      <label for="rating_{{userFeedback.getRating(i)}}"
               [innerHTML]="emoticon"
               class="emoticon">
        </label>
    }
  </div>

  <div class="textareaContainer">
    <mat-form-field appearance="fill">
      <mat-label>{{'GX_WRAPPED.FEEDBACK_PLACEHOLDER' | translate}}</mat-label>
      <textarea formControlName="comment"
                matInput
                appGxInput
                tabindex="-1"></textarea>
    </mat-form-field>
    <div *ngrxLet="userFeedback.loading$; let loading"
         matTooltip="{{'FEEDBACK.BUTTON_TOOLTIP' | translate}}"
         matTooltipPosition="below"
         [matTooltipDisabled]="!userFeedback.feedbackForm.invalid">
      <button mat-flat-button
              [disabled]="userFeedback.feedbackForm.invalid || loading"
              type="submit"
              [ngClass]="{'bg-neutral-90': userFeedback.feedbackForm.invalid || loading}"
              tabindex="-1">
        @if (loading) {
          <mat-spinner [diameter]="24"></mat-spinner>
        } @else {
          {{'SEND' | translate}}
        }
        </button>
    </div>
  </div>

  <div class="footer">{{'GX_WRAPPED.FEEDBACK_FOOTER' | translate}}</div>
</form>
